import { Card, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import BannerCard from "../../../common/components/BannerCard";
import { asDate } from "../../../common/constants/Helpers";
import { buildSummaryRequest } from "../../../state/connect-api";
import { useGetCaseRemarksMutation } from "../../../state/globalApi";
import { updateCaseMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CaseRemarks = () => {
  const { activeCaseNumber, caseMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCaseRemarks, result] = useGetCaseRemarksMutation();
  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctTRCRRemarksTxt",
  ]);

  useEffect(() => {
    const lookupRequest = buildSummaryRequest(activeCaseNumber);
    const fetch = async () => {
      const remarks = await getCaseRemarks(lookupRequest).unwrap();
      dispatch(updateCaseMaster({ remarks: remarks }));
    };

    fetch();
  }, [getCaseRemarks, dispatch, activeCaseNumber]);

  const columns = [
    { key: "date", title: "Date", dataIndex: "DATE", ...asDate },
    { key: "remarks", title: "Remarks", dataIndex: "REMARKS" }
  ];

  return (
    <Row gutter={[16, 16]}>
      {configurations.ctTRCRRemarksTxt && messageVisible && (
        <Col xl={23} lg={23} md={23} sm={23} xs={23}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: configurations.ctTRCRRemarksTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <BannerCard title="Remarks">
          <Table dataSource={caseMaster?.remarks?.LIST} columns={columns} />
        </BannerCard>
      </Col>
    </Row>
  );
};

export default CaseRemarks;
